interface IProps {
    message: string
}

const UserMessage = ({message}: IProps) => {
    return (
        <div className="m-[20px] mr-0 flex items-center justify-end">
            <div className="rounded-2xl rounded-br-none bg-user p-[20px] pb-[12px] pt-[12px]">{message}</div>
        </div>
    )
}

export default UserMessage
